module.exports = __webpack_public_path__ + "static/media/UnBookmarkIcon.219e0909.svg";